export default __webpack_public_path__ + "images/e7617eace4451fc6c814ed7ebf521125-wand.svg";